/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_DetailInputs */

const en_entity_detail = /** @type {(inputs: Entity_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const de_entity_detail = /** @type {(inputs: Entity_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail`)
};

/**
* | output |
* | --- |
* | "Details" |
*
* @param {Entity_DetailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_detail = /** @type {((inputs?: Entity_DetailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_DetailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_detail(inputs)
	return de_entity_detail(inputs)
});
export { entity_detail as "entity.detail" }